export class ContextMenuItem {
  name;
  clickAction;
  payload;

  constructor(name, clickAction, payload = null) {
    if (!name) {
      throw "Context menu item does not have a name.";
    } else if (typeof name !== "string") {
      throw "Context menu item's name must be a string.";
    }

    if (!clickAction) {
      throw "Context menu item does not have a click action.";
    } else if (typeof clickAction !== "function") {
      throw "Context menu item's clickAction must be a function.";
    }

    this.name = name;
    this.clickAction = clickAction;
    this.payload = payload;
  }
}
